// Editor action type constants
export const QE_LOADING = 'QE_LOADING';
export const QE_ERROR = 'QE_ERROR';
export const QE_SHEET_FETCH_ERROR = 'QE_SHEET_FETCH_ERROR';
export const QE_SET_CLUSTER_OPTIONS = 'QE_SET_CLUSTER_OPTIONS';
export const QE_RESET_QUERY_STATE = 'QE_RESET_QUERY_STATE';
export const QE_SET_QUERY_HISTORY_FILTER = 'QE_SET_QUERY_HISTORY_FILTER';
export const QE_SET_QUERY_HISTORY_SEARCH = 'QE_SET_QUERY_HISTORY_SEARCH';
export const QE_SET_ACTIVE_INDEX = 'QE_SET_ACTIVE_INDEX';
export const QE_UPDATE_QUERY_DATA = 'QE_UPDATE_QUERY_DATA';
export const QE_HANDLE_CATALOG_CHANGE = 'QE_HANDLE_CATALOG_CHANGE';
export const QE_SET_DELTA = 'QE_SET_DELTA';
export const QE_SET_QHISTORY_DATA = 'QE_SET_QHISTORY_DATA';
export const QE_UPDATE_STATE = 'QE_UPDATE_STATE';
export const QE_RESET_REF_ID = 'QE_RESET_REF_ID';
export const QE_SET_WS_DISABLED_MESSAGE = 'QE_SET_WS_DISABLED_MESSAGE';
export const QUERY_TEXT = 'QUERY_TEXT';
export const QE_QUERY_FILTER_STATE = 'QE_QUERY_FILTER_STATE';

// Catalog action types (moved from catalog reducer)
export const QE_SET_CATALOG = 'QE_SET_CATALOG';
export const QE_CATALOG_LOADING = 'QE_CATALOG_LOADING';
export const QE_CATALOG_ERROR = 'QE_CATALOG_ERROR';
export const QE_SET_SYSTEM_CATALOG_FLAG = 'QE_SET_SYSTEM_CATALOG_FLAG';
export const QE_SET_CONTINUE_ON_ERROR = 'QE_SET_CONTINUE_ON_ERROR';

// Type union for editor action types
export type EditorActionType =
  | typeof QE_LOADING
  | typeof QE_ERROR
  | typeof QE_SHEET_FETCH_ERROR
  | typeof QE_SET_CLUSTER_OPTIONS
  | typeof QE_RESET_QUERY_STATE
  | typeof QE_SET_QUERY_HISTORY_FILTER
  | typeof QE_SET_QUERY_HISTORY_SEARCH
  | typeof QE_SET_ACTIVE_INDEX
  | typeof QE_UPDATE_QUERY_DATA
  | typeof QE_HANDLE_CATALOG_CHANGE
  | typeof QE_SET_DELTA
  | typeof QE_SET_QHISTORY_DATA
  | typeof QE_UPDATE_STATE
  | typeof QE_RESET_REF_ID
  | typeof QE_SET_WS_DISABLED_MESSAGE
  | typeof QUERY_TEXT
  | typeof QE_QUERY_FILTER_STATE
  | typeof QE_SET_CATALOG
  | typeof QE_CATALOG_LOADING
  | typeof QE_CATALOG_ERROR;
